import React, { useState, useEffect } from "react";
import jwt_decode from "jwt-decode";

interface ITokenResult {
  field: (name: string) => {};
  fields: {};
}

const useToken = (jwttoken: string) => {
  const [token, setToken] = useState<string>();
  const [fields, setFields] = useState<any>({});

  useEffect(() => {
    setToken(jwttoken);
  }, [jwttoken]);

  useEffect(() => {
    if (!token || token === "") {
      setFields({});
      return;
    }
    try {
      const decoded = jwt_decode(token);
      setFields(decoded);
    } catch (e) {
      console.error("Token is invalid, not a JWT token");
      setFields({});
    }
  }, [token]);

  const field = (name: string) => {
    return fields[name];
  };

  return { field, fields };
};

export default useToken;
